import {TabType} from '../types';

export function calculateAmounts(currentTab: TabType, billPackage: any) {
    const amountLeftSMS = billPackage?.smsFreeAmount || 0;
    const amountLeftEmail = billPackage?.emailFreeAmount || 0;
    const amountLeft = currentTab === 'sms' ? amountLeftSMS : amountLeftEmail;
    const total = currentTab === 'sms' ? billPackage?.totalAmounts?.totalSms : billPackage?.totalAmounts?.totalEmails || 0;
    return {amountLeft, total};
}
